module.exports = __webpack_public_path__ + "static/Industrial Lunch Truck Specs CA, NV, AZ, TX 2026-f08b139e303312a5c58898c10f65727b.pdf";